import axios from 'axios'
import store from '@/store'
import router from '@/router'
import md5 from 'md5'
import { Message } from 'view-design'
import currentLangType from '@/utils/currentLangType'
import {
  SET_TOKEN,
  SET_USER_NAME,
  SET_MEMBER_NUMBER,
  SET_USER_INFO,
} from '@/store/mutation-types'

const axiosInstance = axios.create({
  baseURL: `${process.env.VUE_APP_CONTRACT_API}`,
  withCredentials: false,
  // responseType: 'json',
  // headers: {
  //   'Content-Type': 'application/x-www-form-urlencoded',
  // },
})

function Md5Encryption(opt) {
  let keys = []
  let str = ''
  for (let key in opt) {
    // eslint-disable-next-line
    if (opt.hasOwnProperty(key) && opt[key] !== undefined) {
      keys.push(key)
    }
  }

  keys.sort()

  for (let i = 0; i < keys.length; i++) {
    str += keys[i] + opt[keys[i]]
  }

  str += 'bee86d848a27897f7a25e5be46351841'

  console.log(str, '---')
  console.log(md5(str), '---')

  return md5(str)
}

// 添加请求拦截器
axiosInstance.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    config.headers.language = {
      zh: 'zh_CN',
      zh_TW: 'zh_TW',
      en: 'en_US',
    }[currentLangType()]

    if (config.method.toLowerCase() === 'post') {
      const data = {
        ...(config.data || {}),
        exchId: 'JDEX',
        userId: `${store.state.userInfo.userId}`,
        token: store.state.token,
      }
      data.sign = Md5Encryption(data)

      config.data = data
    }

    return config
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 添加响应拦截器
axiosInstance.interceptors.response.use(
  function (response) {
    // 对响应数据做点什么
    const { result, code, msg } = response.data

    if ([100].includes(+code)) {
      return Promise.resolve(result)
    }
    if ([121].includes(+code)) {
      Message.error(msg)

      if (['position', 'history'].includes(router.currentRoute.name)) {
        router.push('/signin')
      }

      store.commit(SET_TOKEN, '')
      store.commit(SET_USER_NAME, '')
      store.commit(SET_USER_INFO, {})
      store.commit(SET_MEMBER_NUMBER, '')

      router.push('/signin')

      return Promise.reject(data)
    }

    if (msg) {
      Message.error(msg)
    }
    return Promise.reject(response.data)
  },
  function (error) {
    let { message } = error
    if (message) {
      const lang = currentLangType()
      if (message.includes('Network Error')) {
        message = {
          zh: '网络异常',
          'zh-TW': '网络异常',
          en: 'Network Error',
        }[lang]
      } else if (message.includes('timeout')) {
        message = {
          zh: '系统接口请求超时',
          'zh-TW': '系统接口请求超时',
          en: 'System API Request Timed Out',
        }[lang]
      } else if (message.includes('Request failed with status code')) {
        message = {
          zh: '系统接口' + message.substr(message.length - 3) + '异常',
          'zh-TW': '系统接口' + message.substr(message.length - 3) + '异常',
          en: 'An error occurred, Please contact the administrator.',
        }[lang]
      }
      Message.error(message)
    }
    return Promise.reject(error)
  }
)

export default axiosInstance
